import {ready} from '~/core'

import { pickit, upload, validate } from '~/utils'

//add date picker functionality
ready('datePicker', '.datePicker input', input => {
	pickit(input);
})

//add file upload functionality
ready('fileUpload', '.fileUpload input', input => {
	upload(input)
})

//add validation functionality
ready('validation', '.formValidate', (form) => {
	validate(form)
})

$(document).on('submit', '[data-ktc-ajax-update]', function() {
	let count = 0;
	$(this).find('input[type=submit]')
		.prop('disabled', true)
		.val('Submitting...');
	
	var interval = setInterval(function() {
		var errors = $('.field-validation-error');
		if (errors.length > 0) {
			const headerOffset = 45;

			let error = errors[0];
			let elementPosition = error.getBoundingClientRect().top;
			let offsetPosition = elementPosition + (window.scrollY || window.pageYOffSet) - headerOffset;
			
			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth"
			});

			clearInterval(interval);
		}

		count++;

		if (count >= 100) {
			clearInterval(interval);
		}
	}, 250);
});